"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductClient = void 0;
const tslib_1 = require("tslib");
const settings_1 = require("../../../../settings");
const authenticated_client_1 = require("../../../authenticated.client");
class ProductClient extends authenticated_client_1.AuthenticatedClient {
    constructor(settings = settings_1.DefaultClientSettings) {
        super(settings);
        this.settings = settings;
        this.executor.setFormatDateWithTimezone(true);
    }
    getAll(projectId, catalogId, request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/catalogs/${catalogId}/products?${this.getQueryString(request)}`);
            return response.payload || [];
        });
    }
    getProductCompetitorMetrics(projectId, catalogId, productId, toCurrency, newService) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/catalogs/${catalogId}/products/${productId}/competitors/metrics?${this.getQueryString({
                toCurrency,
                newService,
            })}`);
            return response.payload;
        });
    }
    getProductOffersPriceRanges(projectId, catalogId, productId, toCurrency, newService) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/catalogs/${catalogId}/products/${productId}/competitors/price-ranges?${this.getQueryString({
                toCurrency,
                newService,
            })}`);
            return response.payload;
        });
    }
    searchProductCompetitorStores(request, newService) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId, catalogId, productId } = request, payload = tslib_1.__rest(request, ["projectId", "catalogId", "productId"]);
            const response = yield this.httpPost(`/v1/projects/${projectId}/catalogs/${catalogId}/products/${productId}/competitors/competitor-stores${newService ? '?newService=true' : ''}`, payload);
            return response.payload;
        });
    }
    searchMarketPlaceResellers(request, newService) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId, catalogId, productId } = request, payload = tslib_1.__rest(request, ["projectId", "catalogId", "productId"]);
            const response = yield this.httpPost(`/v1/projects/${projectId}/catalogs/${catalogId}/products/${productId}/market-place-resellers${newService ? '?newService=true' : ''}`, payload);
            return response.payload;
        });
    }
    downloadCsv(projectId, catalogId, request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/catalogs/${catalogId}/products/export`;
            return this.executeRaw('post', url, request);
        });
    }
    getPriceHistory(projectId, catalogId, productId, request, newService) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/catalogs/${catalogId}/products/${this.encodeValue(productId)}/price-history/${newService ? '?newService=true' : ''}`, request);
            return response.payload;
        });
    }
    getCompetitorHistory(projectId, catalogId, productId, dateTimeFrom, dateTimeTo, newService) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/catalogs/${catalogId}/products/${this.encodeValue(productId)}/price-history-competitors?${this.getQueryString({
                dateTimeFrom,
                dateTimeTo,
                newService,
            })}`);
            return response.payload;
        });
    }
    getProductModel(projectId, catalogId, modelId, request, newService) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/catalogs/${catalogId}/products/${this.encodeValue(modelId)}?${this.getQueryString(Object.assign({ newService }, request))}`);
            return response.payload;
        });
    }
    search(projectId, catalogId, request, newService) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/catalogs/${catalogId}/products${newService ? '?newService=true' : ''}`, request);
            return response.payload || [];
        });
    }
    getProductHighlights(projectId, catalogId, request, newService, integrated) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/catalogs/${catalogId}/product-highlights${integrated ? '?integrated=true' : ''}`, request);
            return response.payload || [];
        });
    }
    getProductOpportunities(projectId, catalogId, request, newService) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/catalogs/${catalogId}/product-opportunities${newService ? '?newService=true' : ''}`, request);
            return response.payload || [];
        });
    }
    downloadXlsx(projectId, catalogId, request, newService) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/catalogs/${catalogId}/products/export${newService ? '?newService=true' : ''}`;
            return this.executeRaw('post', url, request);
        });
    }
    searchProductsContentOnZone(projectId, catalogId, request, newService) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/catalogs/${catalogId}/products/content/zone${newService ? '?newService=true' : ''}`, request);
            return response.payload || [];
        });
    }
    searchProductsAfterEventsOnZone(projectId, catalogId, request, newService) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/catalogs/${catalogId}/products/after-events/zone${newService ? '?newService=true' : ''}`, request);
            return response.payload || [];
        });
    }
}
exports.ProductClient = ProductClient;
//# sourceMappingURL=product.client.js.map